import { I18n } from "@assets/strings";
import React from "react";
import { useSuggestedProfiles } from "@domain/user/hooks";
import { Carousel } from "@ui/components/carousel/carousel";
import { SuggestedProfileThumbnail } from "@ui/components/profile/suggestedUserThumbnail";

type FeedUserSuggestionsProps = React.HTMLAttributes<HTMLDivElement>;
export const FeedUserSuggestions: React.FC<FeedUserSuggestionsProps> = ({ ...htmlProps }) => {
	const { result: profiles, loading } = useSuggestedProfiles(10);

	return (
		<Carousel
			{...htmlProps}
			style={{ marginTop: 20 }}
			items={profiles.filter((p) => !p.followedByMeSince) ?? []}
			renderItem={(profile) => <SuggestedProfileThumbnail key={profile.id} profile={profile} />}
			title={I18n.t("feed.suggestions.users")}
			loading={loading}
			itemHeight={370}
		/>
	);
};
